import * as React from 'react'
import { withRouter } from 'react-router'
import qs from 'qs'

// components
import SearchMallModal from '../../../../components/home/SearchMallModal/SearchMallModal'
import Icon from '../../../../components/ui/Icon/Icon'
import {
  Body,
  CardDescription,
  CardDescriptionWrapper,
  CardImage,
  CloseButton,
  ContentWrapper,
  Description,
  DescriptionHeaderWrapper,
  DescriptionItem,
  DetailCard,
  HeaderTitle,
  HeaderWrapper,
  IconContainer,
  ImageHeader,
  IndoorMapWrapper,
  LoadingContainer,
  LoadingIcon,
  MapDetails,
  MapDetailContent,
  MapDetailContentHeader,
  MerchantLogo,
  PageWrapper,
  ReadMore,
  SelectMallButton,
  StoreLink,
  StoreLinkDescription,
  StoreLinksContainer,
  StyledActionButton,
  StyledHeader,
  StyledIndoorMap,
  StyledLink,
  StyledXIcon,
  Title,
} from './MainView.style'

// services & data
import sanitizeHTML from '../../../../services/sanitizeHTML'
import filterString from '../../../../services/data/filterString'

// analytics
import {
  setGAPageView,
  setGAEvent,
} from '../../../../services/analytics/google-analytics'

// api
import * as ExploreApiService from '../../../../services/api/requests/Explore'

// controllers
import { doGetAllMalls } from '../../../../controllers/Malls'
import { doGetFavoriteMalls } from '../../../../controllers/Profile'

class MainView extends React.Component {
  constructor(props) {
    super(props)

    const queryParams = qs.parse(props.location.search, {
      ignoreQueryPrefix: true,
    })

    this.state = {
      title: null,
      description: null,
      selectedStore: {},
      selectedStoreStatus: null,
      curentTargetLocation: null,
      searchModalState: false,
      detailPageStatus: false,
      webview: !!queryParams.ref || !!props.webview,
    }
  }

  componentDidMount() {
    const {
      setFavoriteMalls,
      accessToken,
      location,
      setMalls,
      match,
    } = this.props
    const { mallSlug } = match.params

    setGAPageView(location.pathname)

    doGetAllMalls({
      setMalls,
      onSuccess: ({ data: malls }) => {
        const currentMall = malls.find(mall => mallSlug === mall.slugName)
        if (currentMall) {
          setGAEvent('wayfinding', 'view_mall_map', currentMall.name)
        }
      },
    })

    doGetFavoriteMalls({ accessToken, setFavoriteMalls })

    this.getSurveyAvailable(accessToken)
  }

  getSurveyAvailable = async accessToken => {
    const { setSurveyModalStatus } = this.props
    if (!accessToken) {
      setSurveyModalStatus(true)
      return
    }

    const surveyAvailable = await ExploreApiService.getSurveyAvailable(
      accessToken,
    )

    setSurveyModalStatus(surveyAvailable.data.toPrompt)
  }

  setChangeMall = e => {
    const { history, baseUrl, malls } = this.props
    const selectMallSlug = e.target.value
    const currentMall = malls.find(mall => selectMallSlug === mall.slugName)

    this.setState({
      title: null,
      description: null,
    })

    setGAEvent('wayfinding', 'view_mall_map', currentMall.name)

    history.push(`${baseUrl}/${e.target.value}`)
  }

  setShowDirection = (locationId, externalId, nextLocationId, accessible) => {
    const { history, baseUrl, match } = this.props
    const { mallSlug } = match.params

    this.setState({
      detailPageStatus: false,
    })

    const newUrl = `${baseUrl}/${mallSlug}/directions/${locationId}${
      nextLocationId
        ? `/from/${nextLocationId}${accessible ? '/accessible' : ''}`
        : ''
    }`

    this.getMerchantData(externalId, locationId)

    if (newUrl !== match.url) {
      history.push(newUrl)
    }
  }

  updateUrlByDirections = ({
    locationId,
    nextLocationId,
    accessible = false,
  }) => {
    const { history, baseUrl, match } = this.props
    const { mallSlug } = match.params

    this.setState({
      detailPageStatus: false,
    })

    const newUrl = `${baseUrl}/${mallSlug}/directions/${locationId || null}${
      nextLocationId && nextLocationId !== 'null'
        ? `/from/${nextLocationId}${accessible ? '/accessible' : ''}`
        : ''
    }`

    if (newUrl !== match.url) {
      history.push(newUrl)
    }
  }

  setShowLocation = (locationId, externalId) => {
    const { history, baseUrl, match } = this.props
    const { mallSlug } = match.params

    const newUrl = `${baseUrl}/${mallSlug}/location/${locationId}`

    this.getMerchantData(externalId, locationId)

    if (newUrl !== match.url) {
      history.push(newUrl)
    }
  }

  setShowLocationDirect = (locationId, externalId) => {
    const { history, baseUrl, match } = this.props
    const { mallSlug } = match.params

    const newUrl = `${baseUrl}/${mallSlug}/directions/${locationId}`

    this.getMerchantData(externalId, locationId)

    if (newUrl !== match.url) {
      history.push(newUrl)
    }
  }

  getMerchantData = async (externalId, locationId) => {
    const { match } = this.props
    const { mallSlug } = match.params
    const { curentTargetLocation } = this.state

    if (curentTargetLocation !== locationId) {
      try {
        this.setState({
          selectedStoreStatus: 0,
          selectedStore: {},
          curentTargetLocation: locationId,
        })

        const merchantResponse = await ExploreApiService.getIndoorMapStore(
          externalId,
          mallSlug,
        )

        this.setState({
          selectedStoreStatus: 4,
          selectedStore: merchantResponse.data,
        })
      } catch (e) {
        this.setState({
          selectedStoreStatus: 4,
        })
      }
    }
  }

  setSearchModeChange = (searchMode, targetLocation) => {
    const { history, baseUrl, match } = this.props
    const { mallSlug } = match.params

    const newUrl = `${baseUrl}/${mallSlug}/${searchMode}${
      targetLocation ? `/${targetLocation}` : ''
    }`

    if (newUrl !== match.url) {
      history.push(newUrl)
    }
  }

  changeDescription = (
    descriptionData = { title: null, description: null },
  ) => {
    const { title, description } = descriptionData

    this.setState({
      title,
      description,
    })
  }

  displayMallDetails = slugName => {
    const { push } = this.props

    push(`/main/malls/${slugName}`)
  }

  handleBack = () => {
    const { history } = this.props

    history.goBack()
  }

  handleChangeMall = mallSlug => {
    const { push, baseUrl } = this.props
    this.setState({
      searchModalState: false,
      title: null,
      description: null,
    })

    push(`${baseUrl}/${mallSlug}`)
  }

  displaySelectMall = state => {
    this.setState({
      searchModalState: state,
    })
  }

  toggleDetailPageStatus = state => {
    this.setState({
      detailPageStatus: state,
    })
  }

  render() {
    const {
      malls,
      match,
      push,
      accessToken,
      baseUrl,
      setFavoriteMalls,
      deviceLocation,
      favoriteMalls,
      setSelectedMallSlug,
      surveyModalStatus,
    } = this.props
    const {
      title,
      description,
      selectedStore,
      selectedStoreStatus,
      searchModalState,
      detailPageStatus,
      webview,
    } = this.state
    const {
      mallSlug,
      actionType,
      actionData,
      addonType,
      addonData,
      extraData,
    } = match.params

    const currentMall = malls.find(({ slugName }) => mallSlug === slugName)

    let mallName = ''
    let mallDescription = ''
    let backgroundImageUrl = ''

    if (currentMall) {
      const { name, description: currentMallDescription, photos } = currentMall
      mallName = name
      mallDescription = currentMallDescription
      backgroundImageUrl = photos && photos[0] ? photos[0].url : ''
    }

    const sidebarTitle = title || mallName
    const sidebarDescription = title ? description : mallDescription

    const targetLocation =
      ['location', 'directions', 'amenities'].indexOf(actionType) >= 0
        ? actionData
        : ''
    const nextTargetLocation =
      actionType === 'directions' && addonType === 'from' ? addonData : ''
    const selectedCategory = actionType === 'categories' ? actionData : ''
    const searchMode =
      ['search', 'amenities', 'categories', 'directions'].indexOf(actionType) >=
      0
        ? actionType
        : ''
    const isAccessible =
      actionType === 'directions' &&
      addonType === 'from' &&
      extraData === 'accessible'

    const selectedMall = malls.find(mall => mall.slugName === mallSlug)
    const selectedMallAddress = selectedMall ? selectedMall.location : ''

    const {
      mall,
      merchant,
      floor,
      contactNumbers,
      operatingHours,
    } = selectedStore

    const {
      name,
      description: merchantDescription,
      logoUrl,
      bannerUrl,
      websiteUrl,
      socialMediaLinks,
    } = merchant || {}

    const { location: storeLocation } = mall || {}

    return (
      <PageWrapper>
        {!webview && (
          <HeaderWrapper>
            <StyledHeader
              match={match}
              initialMall={selectedMall || {}}
              dynamic={false}
            />
          </HeaderWrapper>
        )}
        {!webview && (name || sidebarTitle) && searchMode !== 'directions' ? (
          <DetailCard>
            <CardImage
              image={(targetLocation ? logoUrl : backgroundImageUrl) || ''}
            />
            <CardDescriptionWrapper>
              <DescriptionHeaderWrapper>
                <HeaderTitle>
                  {filterString(
                    targetLocation ? name || sidebarTitle : sidebarTitle,
                  )}
                </HeaderTitle>
                <ReadMore onClick={() => this.toggleDetailPageStatus(true)}>
                  Read more
                </ReadMore>
              </DescriptionHeaderWrapper>
              <CardDescription>
                {filterString(
                  targetLocation
                    ? merchantDescription || sidebarDescription
                    : sidebarDescription,
                )}
              </CardDescription>
            </CardDescriptionWrapper>
          </DetailCard>
        ) : (
          <></>
        )}
        <ContentWrapper>
          <IndoorMapWrapper>
            <StyledIndoorMap
              key={mallSlug}
              mall={mallSlug}
              searchMode={searchMode}
              targetLocation={targetLocation}
              nextTargetLocation={nextTargetLocation}
              isAccessible={isAccessible}
              selectedCategory={selectedCategory}
              webview={webview}
              handleSearchModeChange={this.setSearchModeChange}
              handleChangeMall={this.setChangeMall}
              handleShowDirection={this.setShowDirection}
              handleShowLocationDirect={this.setShowLocationDirect}
              handleShowLocation={this.setShowLocation}
              changeDescription={this.changeDescription}
              handleBack={this.handleBack}
              selectedMallAddress={selectedMallAddress}
              updateUrlByDirections={this.updateUrlByDirections}
              isSurveyAvailable={surveyModalStatus}
              displayProfileModal={this.props.displayProfileModal}
              setProfileModalPage={this.props.setProfileModalPage}
              accessToken={accessToken}
            />
            {!webview && (
              <MapDetails displayMobile={detailPageStatus || !currentMall}>
                <ImageHeader
                  bgImage={
                    (targetLocation ? bannerUrl : backgroundImageUrl) || ''
                  }
                />
                <CloseButton onClick={() => this.toggleDetailPageStatus(false)}>
                  <StyledXIcon />
                </CloseButton>
                <MapDetailContentHeader>
                  <SelectMallButton
                    onClick={() => this.displaySelectMall(true)}
                  >
                    <span>
                      {selectedMall ? selectedMall.name : 'Select Mall'}
                    </span>
                    <Icon name="caret" />
                  </SelectMallButton>
                </MapDetailContentHeader>
                <MapDetailContent>
                  {targetLocation ? (
                    <>
                      {selectedStoreStatus === 0 ? (
                        <LoadingContainer>
                          <LoadingIcon />
                        </LoadingContainer>
                      ) : (
                        <>
                          <MerchantLogo src={logoUrl} />
                          <Title>{name || sidebarTitle}</Title>
                          <Body
                            dangerouslySetInnerHTML={{
                              __html: sanitizeHTML(
                                merchantDescription || sidebarDescription,
                              ),
                            }}
                          />
                          <StoreLinksContainer>
                            {!!contactNumbers &&
                              contactNumbers.map(contactNumber => (
                                <StoreLink key={contactNumber.value}>
                                  <IconContainer>
                                    <Icon name="phone" />
                                  </IconContainer>
                                  <DescriptionItem>
                                    {contactNumber.value}
                                  </DescriptionItem>
                                  <StyledLink
                                    href={`tel:${contactNumber.value}`}
                                  >
                                    Call
                                  </StyledLink>
                                </StoreLink>
                              ))}
                            {!!websiteUrl && (
                              <StoreLink>
                                <IconContainer>
                                  <Icon name="web-link" />
                                </IconContainer>
                                <DescriptionItem>{websiteUrl}</DescriptionItem>
                                <StyledLink
                                  href={websiteUrl}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  VISIT
                                </StyledLink>
                              </StoreLink>
                            )}
                            {!!operatingHours && (
                              <StoreLink type="column">
                                <IconContainer>
                                  <Icon name="location" />
                                </IconContainer>
                                <StoreLinkDescription>
                                  {operatingHours.map(time => (
                                    <p>
                                      {time.name} {time.value}
                                    </p>
                                  ))}
                                </StoreLinkDescription>
                              </StoreLink>
                            )}
                            {!!socialMediaLinks &&
                              socialMediaLinks.map(link =>
                                link && link.value ? (
                                  <StoreLink key={link.value}>
                                    <IconContainer>
                                      <Icon name="social-media" />
                                    </IconContainer>
                                    <DescriptionItem>
                                      {link.value}
                                    </DescriptionItem>

                                    <StyledLink
                                      href={link.value}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      Visit
                                    </StyledLink>
                                  </StoreLink>
                                ) : null,
                              )}
                            {!!storeLocation && (
                              <StoreLink>
                                <IconContainer>
                                  <Icon name="location" />
                                </IconContainer>
                                <DescriptionItem>
                                  {floor && `${floor}, `}
                                  {mallName && `${mallName}, `}
                                  {storeLocation && `${storeLocation}`}
                                </DescriptionItem>
                                <StyledLink
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  href={`https://www.google.com/maps?q=${storeLocation}`}
                                >
                                  Visit
                                </StyledLink>
                              </StoreLink>
                            )}
                          </StoreLinksContainer>
                        </>
                      )}
                    </>
                  ) : (
                    <>
                      <Title>{sidebarTitle}</Title>
                      <Description>{sidebarDescription}</Description>
                    </>
                  )}
                  {title ? (
                    <StyledActionButton
                      variant="primary"
                      onClick={() => this.setShowDirection(targetLocation)}
                      disabled={
                        searchMode === 'directions' &&
                        targetLocation &&
                        nextTargetLocation
                      }
                    >
                      Get Directions
                    </StyledActionButton>
                  ) : (
                    !!mallName && (
                      <StyledActionButton
                        variant="primary"
                        onClick={() => this.displayMallDetails(mallSlug)}
                      >
                        About {mallName}
                      </StyledActionButton>
                    )
                  )}
                </MapDetailContent>
              </MapDetails>
            )}
          </IndoorMapWrapper>
        </ContentWrapper>
        <SearchMallModal
          modalState={searchModalState}
          onClose={() => this.displaySelectMall(false)}
          malls={malls}
          mallList={malls}
          push={push}
          match={match}
          baseUrl={baseUrl}
          accessToken={accessToken}
          setFavoriteMalls={setFavoriteMalls}
          currentMall={currentMall}
          onChangeMall={this.handleChangeMall}
          selectedMall
          deviceLocation={deviceLocation}
          favoriteMalls={favoriteMalls}
          displayClose
          setSelectedMallSlug={setSelectedMallSlug}
        />
      </PageWrapper>
    )
  }
}

export default withRouter(MainView)
